import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { clearSupportSession } from "../services/supportTestSessionService";
import {
  clearActiveAccessToken,
  getAccessToken as getStoredAccessToken,
} from "../services/authStorage";

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const getAccessToken = () => {
    return getStoredAccessToken();
  };

  const isTokenExpired = (token: string | null) => {
    if (!token) return true;
    const decoded: any = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return decoded.exp < currentTime;
  };

  useEffect(() => {
    const accessToken = getAccessToken();

    if (!accessToken) {
      setIsAuthenticated(false);
      setIsLoading(false);
      return;
    }

    if (isTokenExpired(accessToken)) {
      clearActiveAccessToken();
      clearSupportSession();
      alert("Su sesión ha expirado");
      setIsAuthenticated(false);
      location.reload();
    } else {
      setIsAuthenticated(true);
    }

    setIsLoading(false);
  }, []);

  if (isLoading) {
    return <div></div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
